import ActionTypes from "../inc/ActionsTypes";

const defaultState = {
    types:[]
}
const AttachmentTypes = (state = defaultState, actions) =>{
    if(actions.type === ActionTypes.SET_ATTACHMENT_TYPES){
        state = {
            ...state,
            types:actions.payload
        }
    }
    return state;
}
export default AttachmentTypes;